import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Endereco from '../../../../../models/perfil/endereco.model';
import { LoadingService } from '../../../../../util/loader.service';
import { environment } from '../../../../../../environments/environment';
import { MapMouseEvent, Map, LngLat } from 'mapbox-gl';
//import * as mapboxgl from 'mapbox-gl';


@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  styleUrls: ['./endereco.component.scss']
})
export class EnderecoComponent implements OnInit {
  valForm: FormGroup;
  record: Endereco;
  map: Map;
  _zoom: number;
  index: number;
  _center: LngLat;
  set zoom(z: number) {
    this._zoom = z;
    if (this.index === 0) {
      // this.zoomChange.emit(this._zoom);
    }
  }
  //refs
  _mapRef: Map;

  constructor(fb: FormBuilder,
    public loader: LoadingService) {
    this.valForm = fb.group({
      'receitaFederalEmpresaEstado': [null, [Validators.required]],
      'receitaFederalEmpresaCidade': [null, [Validators.required]],
      'receitaFederalEmpresaBairro': [null, [Validators.required]],
      'receitaFederalEmpresaLogradouro': [null, [Validators.required]],
      'receitaFederalEmpresaCep': [null, [Validators.required]],
      receitaFederalEmpresaNumero: [null, [Validators.required]],

    });

    this.record = new Endereco();

  }
  onMapLoad(map) {
    debugger;
    map.resize();
    console.log("Initializing map, _center: ", this._center);
    console.log("map: ", map);
    this._mapRef = map;
    this.map = map;
    console.log("Loading map data");
    this._center = map.getCenter();
    console.log('this._center from map: ', this._center);
    this._mapRef.resize();
    this.map.resize();

    setTimeout(function () {
      if (this.map != null) {
        this.map.resize();
      }
    }, 1000);
  }
  ngOnInit() {
    this.zoom = 11;
    this._center = new LngLat(-121.31209, 37.449904);
  }

}
//https://stackblitz.com/edit/ngx-mapbox-gl?file=package.json
//https://www.gitmemory.com/issue/Wykks/ngx-mapbox-gl/98/495319714
